module.exports = __webpack_public_path__ + "static/media/RP-B_S_Fashion_Roseto Sand_DK Grey.f47ba62b.png";